// extracted by mini-css-extract-plugin
export var marquee = "marquee-module--marquee--dNKo4";
export var scrollContainer = "marquee-module--scroll-container--PTifS";
export var scrollContent = "marquee-module--scroll-content--+TwBR";